import { ConditionParams } from './types';

export function isB2BFlow(state: ConditionParams) {
  return state.flowType === 'b2b';
}

export function isB2CFlow(state: ConditionParams) {
  return state.flowType === 'b2c';
}

export function isComplexFlow(state: ConditionParams) {
  return state.flowComplexity === 'complex';
}

export function isSimpleFlow(state: ConditionParams) {
  return state.flowComplexity === 'simple';
}
